var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7083 13.3333H13.9842L13.7275 13.0858C14.6258 12.0408 15.1667 10.6842 15.1667 9.20833C15.1667 5.9175 12.4992 3.25 9.20833 3.25C5.9175 3.25 3.25 5.9175 3.25 9.20833C3.25 12.4992 5.9175 15.1667 9.20833 15.1667C10.6842 15.1667 12.0408 14.6258 13.0858 13.7275L13.3333 13.9842V14.7083L17.9167 19.2825L19.2825 17.9167L14.7083 13.3333ZM9.20833 13.3333C6.92583 13.3333 5.08333 11.4908 5.08333 9.20833C5.08333 6.92583 6.92583 5.08333 9.20833 5.08333C11.4908 5.08333 13.3333 6.92583 13.3333 9.20833C13.3333 11.4908 11.4908 13.3333 9.20833 13.3333Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4993 9.66602H9.66602V11.4993H8.74935V9.66602H6.91602V8.74935H8.74935V6.91602H9.66602V8.74935H11.4993V9.66602Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.6f0862a66f5ad46dc8740f40af128cf1.svg";
export { ForwardRef as ReactComponent };